import civicServants from "./civicServants/definition";
import dojosaurus from "./dojosaurus/definition";
import firstActivity from "./firstActivity/definition";
import intro from "./firstActivity/definition";
import mojoLisa from "./mojoLisa/definition";
import spaceStation from "./spaceStation/definition";
import { Activity } from "./types";

const activities: {
  [name: string]: Activity;
} = {
  firstActivity,
  civicServants,
  mojoLisa,
  spaceStation,
  dojosaurus,
  intro,
};

export default activities;
